/*
 * <hero-slider> — minimal slider for the hero section.
 * Supports slide (CSS scroll-snap) and fade effects, autoplay (pauses on hover),
 * prev/next arrows, and dot/line indicators. No dependencies.
 * Attributes: effect="slide|fade", autoplay="<ms>" (0 = off).
 */
customElements.define(
  'hero-slider',
  class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.dots = [...this.querySelectorAll('[data-dot]')];
      this.count = this.slides.length;
      this.index = 0;
      this.fade = this.getAttribute('effect') === 'fade';
      if (this.count <= 1) return;

      this.querySelector('[data-prev]')?.addEventListener('click', () => this.go(this.index - 1, true));
      this.querySelector('[data-next]')?.addEventListener('click', () => this.go(this.index + 1, true));
      this.dots.forEach((d, i) => d.addEventListener('click', () => this.go(i, true)));

      if (!this.fade && this.track) {
        this.io = new IntersectionObserver(
          (es) => es.forEach((e) => { if (e.isIntersecting) this.setActive(this.slides.indexOf(e.target)); }),
          { root: this.track, threshold: 0.55 }
        );
        this.slides.forEach((s) => this.io.observe(s));
      }

      const speed = Number(this.getAttribute('autoplay')) || 0;
      if (speed > 0) {
        this.play = () => { this.stop(); this.timer = setInterval(() => this.go(this.index + 1), speed); };
        this.stop = () => clearInterval(this.timer);
        this.play();
        this.addEventListener('pointerenter', () => this.stop());
        this.addEventListener('pointerleave', () => this.play());
        this.addEventListener('focusin', () => this.stop());
      }
    }

    go(i, user) {
      this.index = (i + this.count) % this.count;
      if (this.fade) {
        this.slides.forEach((s, j) => { s.style.opacity = j === this.index ? '1' : '0'; s.style.zIndex = j === this.index ? '1' : '0'; });
        this.setActive(this.index);
      } else {
        this.slides[this.index].scrollIntoView({ behavior: user ? 'smooth' : 'auto', inline: 'start', block: 'nearest' });
      }
    }

    setActive(i) {
      this.index = i;
      this.dots.forEach((d, j) => d.setAttribute('aria-current', j === i ? 'true' : 'false'));
    }

    disconnectedCallback() { this.io?.disconnect(); clearInterval(this.timer); }
  }
);
